<template>
  <main>
    <menus class="menus"/>
    <section class="user_info">
      <ul>
        <li>
          <span>用户名称：</span>
          <el-input v-model="submit.name"></el-input>
        </li>
        <li>
          <span>企业名称：</span>
          <el-input v-model="submit.company_name"></el-input>>

        </li>
        <li>
          <span>联系人：</span>
          <el-input v-model="submit.ContanctPerson"></el-input>
        </li>
        <li>
          <span>联系电话：</span>
          <el-input v-model="submit.ContanctPhone"></el-input>
        </li>
        <li>
          <span>电子邮箱：</span>
          <el-input v-model="submit.Email"></el-input>
        </li>
        <li class="max">
          <span>详细地址：</span>
          <el-cascader
            v-model="submit.citys"
            :options="chinaCity"
            :props="cityProps"
            clearable
            filterable></el-cascader>
          <el-input placeholder="请输入详细地址" v-model="submit.address"></el-input>
        </li>
        <li class="max license">
          <span>营业执照：</span>
          <label for="license"><input type="file" id="license" accept="image/*"></label>
        </li>
      </ul>
      <el-button type="primary" @click='next' >保存</el-button>
    </section>
  </main>
</template>

<script>
import menus from '@components/menu';
import $user from '@api/user';

import { mapState } from 'vuex';
export default {
  components: {
    menus
  },
  data () {
    return {
      chinaCity: [],
      cityProps: {
        expandTrigger: 'hover',
        label: 'name',
        value: 'name'
      },
      submit: {
        name: '', // 客户名称
        citys: [], // 选择的城市列表
        address: '', // 详细地址
        company_name: '', // 企业名称
        ContanctPerson: '', // 联系人
        ContanctPhone: '', // 联系电话
        Email: '', // 电子邮箱
        AttacUrl: '', // 营业执照
      },
    }
  },
  computed: {
    ...mapState([
      'userInfo'
    ])
  },
  created () {
    this.chinaCity = window.china_citys;
    console.log('userINfo', this.userInfo);
  },
  methods: {
    next(){
    console.log('1234userINfo');
    const data = this.submit;
      console.log('用户信息'+JSON.stringify(data))
      // return
      $user.updateInfo(data).then(res => {
        this.$message.success('资料更新成功!');

    console.log('gengxin');

        // this.step = 2;
        // this.countdown();
      })
    }
  }
}
</script>

<style scoped src="./update_info.css"></style>